module.exports = __webpack_public_path__ + "img/MESSAGE.b18da1c9.svg";